import { ChangeDetectionStrategy, Component, ContentChild } from '@angular/core';
import { EmptyIconDirective } from './empty-icon.directive';
import { IconComponent } from '../../../icon/icon.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'td-wb-empty',
    templateUrl: 'empty.component.html',
    styleUrls: ['empty.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, IconComponent]
})
export class EmptyComponent {
  @ContentChild(EmptyIconDirective) customIcon: EmptyIconDirective;
}
